export const sideNav = () => {
  const toggle = event => {
    const { sideNavToggle } = event.target.dataset
    const sideNavTarget = document.querySelector('[data-side-nav=side]')
    const sideNavBody = document.querySelector('[data-side-nav-for=side]')

    sideNavTarget && sideNavTarget.setAttribute('data-side-nav-status', sideNavToggle)
    sideNavBody && sideNavBody.setAttribute('data-side-nav-status', sideNavToggle)

    sideNavToggle === 'open'
      ? document.body.classList.add('no-overflow')
      : document.body.classList.remove('no-overflow')
  }

  document
    .querySelectorAll('[data-side-nav-toggle]')
    .forEach(target => target.addEventListener('click', toggle))
}
